export default __webpack_public_path__ + "static/media/ppt.1bba2268.svg";